import { Report } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { Study } from '@/shared/api/protocol-ts/model/dto_study_pb';

import { distributeReportsAndStudies } from './distributeReportsAndStudies';
import { getGroupedReportsBySourceStudyIDs } from './getGroupedReportsBySourceStudyIDs';
import { getGroupedReportsBySourceStudyIDsAndType } from './getGroupedReportsBySourceStudyIDsAndType';
import { getGroupedReportsWithStudies } from './getGroupedReportsWithStudies';
import { getSortedStructuredReportsAndStudies } from './getSortedStructuredReportsAndStudies';
import { getStructuredReportsAndStudies } from './getStructuredReportsAndStudies';

export const buildStructuredReportsAndStudies = (
  studies: Study[],
  reports: Report[],
) => {
  const groupedReportsBySourceStudyIDs =
    getGroupedReportsBySourceStudyIDs(reports);

  const groupedReportsBySourceStudyIDsAndType =
    getGroupedReportsBySourceStudyIDsAndType(groupedReportsBySourceStudyIDs);

  const groupedReportsWithStudies = getGroupedReportsWithStudies(
    groupedReportsBySourceStudyIDsAndType,
    studies,
  );

  const structuredReportsAndStudies = getStructuredReportsAndStudies(
    groupedReportsWithStudies,
  );

  const sortedStructuredReportsAndStudies =
    getSortedStructuredReportsAndStudies(structuredReportsAndStudies);

  const [leftColumn, rightColumn] = distributeReportsAndStudies(
    sortedStructuredReportsAndStudies,
  );

  return { leftColumn, rightColumn, sortedStructuredReportsAndStudies };
};
